import { useEffect, useState } from "react";
import Staff from "../../actions/staff";
import {
  Grid,
  Autocomplete,
  FormHelperText,
  MenuItem,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import Controls from "../../components/controls/Controls";
import { Form } from "../../components/customHelpers/useForm";
import CheckIcon from "@mui/icons-material/Check";
import Organization from "../../actions/organization";

const Assignstaff = ({
  NotifyMessage,
  setOpenPopup,
  id,
  getAllOrders,
  handleStatusChange,
  event,
  type,
}) => {
  const { assignStaff } = Staff();
  const { viewOrganizations } = Organization();
  const [organization, setOrganization] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null); // Updated to store full staff info
  const [roleError, setRoleError] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllOrganizations();
  }, []);

  const getAllOrganizations = () => {
    setValues({ ...values, loading: true });
    viewOrganizations().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.organizations) {
        setValues({
          ...values,
          loading: false,
        });
        setOrganization(data.organizations);
      }
    });
  };
  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedOrganization(newValue); // Store full staff info
    }
  };

  const handleSubmit = () => {
    setValues({ ...values, loading: true });
    assignStaff({ staffId: id, organizationId: selectedOrganization.id }, id).then(
      (data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
          setValues({ ...values, loading: false });
        } else if (data.staff) {
          NotifyMessage({
            message: "Admin Assigned",
            type: "success",
          });
          setOpenPopup(false);
          setValues({ ...values, loading: false });
        }
      }
    );
  };

  const handleAddClick = (e) => {
    e.preventDefault();

    if (selectedOrganization === null) {
      setRoleError(true);
    } else {
      setRoleError(false);
      handleSubmit();
    }
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <>
            <Autocomplete
              options={organization}
              getOptionLabel={(option) => option.organization_name}
              onChange={handleChange}
              value={selectedOrganization} 
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="Select Organization" />
              )}
              renderOption={(props, option, { selected }) => (
                <MenuItem
                  {...props}
                  key={option.id}
                  value={option.id}
                  sx={{ justifyContent: "space-between" }}
                >
                  {option.organization_name}
                  {selected ? <CheckIcon color="info" /> : null}
                </MenuItem>
              )}
            />
            {roleError && (
              <FormHelperText error>Please select one Organization</FormHelperText>
            )}
          </>
        </Grid>

        {selectedOrganization && (
          <Grid item xs={12} md={6}>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {selectedOrganization.phoneNo}
              </Typography>
              <Typography variant="body1">
                <strong>Email:</strong> {selectedOrganization.email}
              </Typography>
            </Box>
          </Grid>
        )}
        {!selectedOrganization && <Grid item xs={12} md={6} />}

        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              text={"Assign"}
              disabled={values.submitting ? true : false}
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default Assignstaff;
